// Bearbeitung PF: Parallax für die bestehende Flex-Slider-Section
(function () {
  const SPEED = 0.18;

  const reduceMotion = window.matchMedia &&
                       window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  function setup(section) {
    if (!section || section.classList.contains('parallax-ready')) return;
    section.classList.add('parallax-ready');
  }

  function getTargets(root) {
    return root.querySelectorAll('.card__image--background .lazy-image--background img');
  }

  function updateSection(section) {
    const vh = window.innerHeight;
    getTargets(section).forEach(img => {
      const host = img.closest('.card__image--background') || img.parentElement;
      if (!host) return;
      const rect = host.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      const progress = (vh - rect.top) / (vh + rect.height);
      const shift = (progress - 0.5) * 2 * SPEED * 100; // in vh
      img.style.transform = `translateY(${shift}vh) scale(1.08)`;
    });
  }

  let ticking = false;
  function onScrollResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      document.querySelectorAll('[id^="slider-template"][id*="flex_slideshow"]')
        .forEach(updateSection);
      ticking = false;
    });
  }

  function init(root = document) {
    const sections = root.querySelectorAll('[id^="slider-template"][id*="flex_slideshow"]');
    sections.forEach(setup);
    onScrollResize();
  }

  // Initial
  window.addEventListener('load', init, { passive: true });
  window.addEventListener('scroll', onScrollResize, { passive: true });
  window.addEventListener('resize', onScrollResize, { passive: true });

  // Theme-Editor / dynamisches Nachladen
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:reorder', e => init(e.target));
  document.addEventListener('shopify:block:select', onScrollResize);
  document.addEventListener('shopify:block:deselect', onScrollResize);

  // Falls der Slider Bilder lazy nachlädt/DOM klont
  const mo = new MutationObserver(() => onScrollResize());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
